import get from 'lodash/get';

export default content => ({
  title: get(content, 'title.label', ''),
  titleHtmlTag: get(content, 'title.htmlTag', ''),
  data: get(content, 'faqQuestions', []),
  text: get(content, 'text', '')
});
